import { render } from "./DeployVnfAppliance.vue?vue&type=template&id=2d63b4a1&scoped=true"
import script from "./DeployVnfAppliance.vue?vue&type=script&lang=js"
export * from "./DeployVnfAppliance.vue?vue&type=script&lang=js"

import "./DeployVnfAppliance.vue?vue&type=style&index=0&id=2d63b4a1&lang=less&scoped=true"
import "./DeployVnfAppliance.vue?vue&type=style&index=1&id=2d63b4a1&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d63b4a1"]])

export default __exports__